<div class="auth-modal-backdrop" *ngIf="isVisible" (click)="close()" (keydown.escape)="close()" tabindex="-1"
  aria-hidden="false">

  <section class="auth-modal-panel" role="dialog" aria-modal="true" [attr.aria-labelledby]="'auth-modal-title'"
    [attr.aria-busy]="submitting ? 'true' : 'false'" (click)="$event.stopPropagation()">

    <div class="modal-layout">
      <div class="info-column">
        <div class="info-header">
          <div class="auth-logo" aria-hidden="true">NEXTRA GLOBAL</div>

        </div>

        <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>
        <div class="message success" *ngIf="successMessage">{{ successMessage }}</div>

        <div class="form-block form-block--compact" *ngIf="activeTab === 'login'">
          <label class="form-field" for="login-user">
            <span class="required-label">Tên đăng nhập</span>
            <input id="login-user" type="text" name="loginUser" [(ngModel)]="loginForm.userName" [disabled]="submitting"
              placeholder="Nhập tên đăng nhập" />
          </label>

          <label class="form-field" for="login-password">
            <span class="required-label">Mật khẩu</span>
            <div class="auth-password-wrap">
              <input id="login-password" [type]="showLoginPassword ? 'text' : 'password'" name="loginPassword"
                [(ngModel)]="loginForm.password" [disabled]="submitting" placeholder="Nhập mật khẩu đăng nhập" />
              <button type="button" class="auth-password-toggle" (click)="toggleLoginPasswordVisibility()"
                [disabled]="submitting" [attr.aria-label]="showLoginPassword ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'"
                [attr.aria-pressed]="showLoginPassword">
                <svg class="auth-password-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <path d="M2.5 12s3.5-7 9.5-7 9.5 7 9.5 7-3.5 7-9.5 7S2.5 12 2.5 12Z" fill="none" stroke="currentColor"
                    stroke-width="1.8" stroke-linejoin="round" />
                  <path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" fill="none" stroke="currentColor"
                    stroke-width="1.8" />
                  <path *ngIf="!showLoginPassword" d="M4 4l16 16" fill="none" stroke="currentColor" stroke-width="1.8"
                    stroke-linecap="round" />
                </svg>
              </button>
            </div>
          </label>

          <div class="login-help-row">
            <span class="forgot-password">Quên mật khẩu?</span>
          </div>

          <div class="form-actions form-actions--login">
            <button type="button" class="primary-btn" (click)="submitLogin()" [disabled]="!canLogin()"
              [attr.aria-busy]="submitting ? 'true' : null">
              <span *ngIf="!submitting">Đăng nhập</span>
              <span *ngIf="submitting">Đang xử lý...</span>
            </button>
          </div>

          <div class="login-switch-row">
            <span>Chưa có tài khoản?</span>
            <button type="button" class="hint-link" (click)="setTab('register')" [disabled]="submitting">
              Đăng ký ngay
            </button>
          </div>
        </div>

        <div class="form-block" *ngIf="activeTab === 'register'">
          <div class="form-row full">
            <label class="form-field" for="register-code">
              <span class="required-label">Tên đăng nhập</span>
              <input id="register-code" type="text" name="registerCode" [(ngModel)]="registerForm.userCode"
                [disabled]="submitting" placeholder="Nhập tên đăng nhập" />
            </label>
          </div>

          <div class="form-row full">
            <label class="form-field" for="register-name">
              <span class="required-label">Tên hiển thị</span>
              <input
                id="register-name"
                type="text"
                name="registerName"
                [(ngModel)]="registerForm.userName"
                [disabled]="submitting"
                placeholder="Nguyễn Văn A" />
            </label>
          </div>

          <div class="form-row full">
            <label class="form-field" for="register-password">
              <span class="required-label">Mật khẩu</span>
              <input id="register-password" type="password" name="registerPassword" [(ngModel)]="registerForm.password"
                (input)="onRegisterPasswordInput()" [disabled]="submitting"
                [attr.maxlength]="registerPasswordPolicy.maxLength" [attr.minlength]="registerPasswordPolicy.minLength"
                pattern="(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,20}" autocomplete="new-password"
                placeholder="Nhập mật khẩu đăng nhập" />


            </label>
          </div>

          <div class="form-row full">
            <label class="form-field" for="register-confirm-password">
              <span class="required-label">Xác nhận mật khẩu</span>
              <input id="register-confirm-password" type="password" name="registerConfirmPassword"
                [(ngModel)]="registerForm.confirmPassword" [disabled]="submitting" placeholder="Nhập lại mật khẩu" />
              <div class="password-rules" aria-live="polite">
                <span class="password-rule" [class.valid]="registerPasswordValid.length">
                  8-20 ký tự
                </span>

                <span class="password-rule" [class.valid]="registerPasswordValid.uppercase">
                  1 chữ hoa
                </span>

                <span class="password-rule" [class.valid]="registerPasswordValid.number">
                  1 số
                </span>

                <span class="password-rule" [class.valid]="registerPasswordValid.special">
                  Ký tự đặc biệt
                </span>
              </div>

              <div class="field-error" *ngIf="registerForm.password && !isRegisterPasswordStrong()">
                Mật khẩu chưa đủ mạnh
              </div>
              <div class="field-error"
                *ngIf="registerForm.password && registerForm.confirmPassword && registerForm.password !== registerForm.confirmPassword">
                Mật khẩu không khớp
              </div>
            </label>
          </div>

          <div class="form-row">
            <label class="form-field">
              <label class="form-field bank-field">
                <span class="required-label">Chọn ngân hàng</span>

                <input type="text" [(ngModel)]="bankKeyword" (input)="filterBanks()" (focus)="showBankDropdown = true"
                  placeholder="Nhập tên ngân hàng" />

                <div class="bank-dropdown" *ngIf="showBankDropdown">
                  <div class="bank-item" *ngFor="let bank of filteredBanks; trackBy: trackByBank"
                    (mousedown)="selectBank(bank)">

                    <img [src]="bank.logo" alt="" class="bank-logo" />

                    <div class="bank-info">
                      <div class="bank-name">
                        {{ bank.shortName }}
                      </div>

                      <div class="bank-fullname">
                        {{ bank.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </label>
            </label>

            <label class="form-field">
              <span class="required-label">Số tài khoản</span>
              <input type="text" [(ngModel)]="registerForm.bankAccountNumber"
                [disabled]="submitting" placeholder="Nhập số tài khoản" />
            </label>
          </div>

          <div class="form-row">
            <label class="form-field">
              <span class="required-label">Tên chủ tài khoản</span>
               <input type="text" [(ngModel)]="registerForm.bankAccountName"
                [disabled]="submitting" placeholder="Nhập tên chủ tài khoản" />
            </label>

            <label class="form-field">
              <span>Tên chi nhánh</span>
              <input type="text" [(ngModel)]="registerForm.bankBranch"
                [disabled]="submitting" placeholder="Nhập chi nhánh ngân hàng" />
            </label>
          </div>
          <div class="form-row full">
            <label class="form-field">
              <span class="required-label">Mật khẩu rút tiền</span>
              <input type="password" [(ngModel)]="registerForm.passwordBank"
                [disabled]="submitting" placeholder="Tạo mật khẩu mới để sử dụng khi rút tiền của hệ thống" />
            </label>
          </div>

          <div class="form-actions">
            <button type="button" class="primary-btn" (click)="submitRegister()" [disabled]="!canRegister()"
              [attr.aria-busy]="submitting ? 'true' : null">
              <span *ngIf="!submitting">Đăng ký</span>
              <span *ngIf="submitting">Đang xử lý...</span>
            </button>
          </div>

          <div class="register-switch-row">
            <span>Bạn đã có tài khoản?</span>
            <button type="button" class="hint-link" (click)="setTab('login')" [disabled]="submitting">
              Đăng nhập tại đây
            </button>
          </div>
        </div>
      </div>

    </div>
  </section>
</div>